export const COLLECTION_SORT_KEYS = [
    'POPULARITY',
    'DATE_ASC',
    'DATE_DESC',
    'PRICE_ASC',
    'PRICE_DESC',
    'ALPHABETICAL_ASC',
    'ALPHABETICAL_DESC',
];
